import React from "react";
import CrossSellingFake from "./cross-selling-fake";
import R2RInfoTextFake from "./r2r-info-data-fake";
import styles from "./styles.js";

const FakeGeneralManagment = ({ withOutContainer }) => {
  return (
    <>
      <div className={withOutContainer ? "" : "container"}>
        <div className={`devices-fake`}>
          <div className="devices-fake--container">
        <div className="skeleton devices-fake--container--box-container--info--title" />
            <div className="devices-fake--container--box-container">
              <div className="devices-fake--container--box-container--column">
                <div className="skeleton devices-fake--container--box-container--image" />
                <div className="devices-fake--container--box-container--info">
                  <div className="skeleton devices-fake--container--box-container--info--title" />
                  <R2RInfoTextFake />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="skeleton devices-fake--text-footer" />
          <div className="skeleton devices-fake--footer" /> */}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FakeGeneralManagment;
